"use client";

import { FAQSection } from "@/components/sections/faq";
import { faq } from "@/lib/data/services-competitive-intelligence";

export function FAQ() {
  return (
    <FAQSection
      eyebrow={faq.eyebrow}
      title={faq.title}
      accent={faq.accent}
      items={faq.items}
    />
  );
}